/**
    * @description      : 
    * @author           : Saif
    * @group            : 
    * @created          : 04/11/2024 - 22:59:59
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 04/11/2024
    * - Author          : Saif
    * - Modification    : 
**/
import { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faEye, faCheck, faTimes, faFilter, faEdit, faTrash, faCheckCircle, faTimesCircle, faSlash, faWarning } from "@fortawesome/free-solid-svg-icons";

import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import CustomTable from "../../Components/CustomTable";
import CustomModal from "../../Components/CustomModal";
import TableDropdown from "../../Components/TableDropdown";

import CustomPagination from "../../Components/CustomPagination"
import CustomInput from "../../Components/CustomInput";
import CustomButton from "../../Components/CustomButton";


import "./style.css";
import { useDelete, useGet, usePost } from "../../Api";
import { male1 } from "../../Assets/images";
import FormatDateTime from "../../Components/DateFormate";
import { base_url } from "../../Api/apiConfig";
import { useNotification } from '../../Components/GlobalNotification';

import { faSquareLastfm } from "@fortawesome/free-brands-svg-icons";

const getListingImageUrl = (imageUrl) => {
  if (!imageUrl) return null;
  if (String(imageUrl).startsWith('http')) return imageUrl;
  return `${base_url}/storage/${String(imageUrl).replace(/^\/+/, '')}`;
};

export const ListingManagement = () => {
  const { showNotification } = useNotification();

  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [inputValue, setInputValue] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [delId, setDelId] = useState(null);
  const [listApprovedID, setListApprovedID] = useState(null);
  const [listRejectID, setListRejectID] = useState(null);
  const { ApiData: UseeListingData, loading: UseeListingLoading, error: UseeListingError, get: GetUseeListing } = useGet(`/listings?page=${currentPage}&filter=published${searchTerm ? `&search=${encodeURIComponent(searchTerm)}` : ''}`);
  const { ApiData: DelListData, loading: DelListLoading, error: DelListError, del: GetDelList } = useDelete(`/listings/${delId}`);
  const { ApiData: ApprovedData, loading: ApprovedLoading, error: ApprovedError, post: GetApproved } = usePost(`/listings/${listApprovedID}/approve`);
  const { ApiData: RejectData, loading: RejectLoading, error: RejectError, post: GetReject } = usePost(`/listings/${listRejectID}/disapprove`);


  const navigate = useNavigate();

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  // Approved 

  useEffect(() => {
    if (listApprovedID != null) {
      GetApproved('')
    }
  }, [listApprovedID])

  useEffect(() => {
    if (ApprovedData) {
      showNotification({ type: 'info', title: 'Information', message: ApprovedData?.message });
      GetUseeListing()
    }
  }, [ApprovedData])


  // Reject 


  useEffect(() => {
    if (listRejectID != null) {
      GetReject('')
    }
  }, [listRejectID])

  useEffect(() => {
    if (RejectData) {
      showNotification({ type: 'info', title: 'Information', message: RejectData?.message });
      GetUseeListing()
    }
  }, [RejectData])

  useEffect(() => {
    if (currentPage) {
      GetUseeListing()
    }
  }, [currentPage])


  const handleRemove = (del) => {
    setDelId(del)
  }

  useEffect(() => {
    if (delId != null) {
      GetDelList();
    }
  }, [delId])

  useEffect(() => {
    if (DelListData) {
      showNotification({ type: 'info', title: 'Information', message: DelListData?.message })
      GetUseeListing()
    }
  }, [DelListData])

  const hanldeRoute = () => {
    navigate('/add-listing')
  }


  const inActive = () => {
    setShowModal(false)
    setShowModal2(true)
  }
  const ActiveMale = () => {
    setShowModal3(false)
    setShowModal4(true)
  }

  const handleChange = (e) => {
    setInputValue(e.target.value);
  }

  // Search runs on the server (all pages): wait until typing stops, then go back to page 1
  useEffect(() => {
    const timer = setTimeout(() => setSearchTerm(inputValue.trim()), 400);
    return () => clearTimeout(timer);
  }, [inputValue]);

  const searchMounted = useRef(false);
  useEffect(() => {
    if (!searchMounted.current) { searchMounted.current = true; return; }
    if (currentPage !== 1) setCurrentPage(1);
    else GetUseeListing();
  }, [searchTerm]);


  // The server already filtered every page for the current search term
  const filteredListings = Array.isArray(data?.data) ? data.data : [];

  useEffect(() => {
    document.title = 'Kvr Listing Management';
    GetUseeListing()

  }, []);


  useEffect(() => {
    if (UseeListingData) {
      setData(UseeListingData?.data)
      setItemsPerPage(UseeListingData?.data?.per_page)
    }
  }, [UseeListingData])

  const upcomingHeader = [
    {
      key: "id",
      title: "S.No",
    },
    {
      key: "Thumbnail",
      title: "Thumbnail",
    },
    {
      key: "title",
      title: "Title",
    },
    {
      key: "Address",
      title: "Address",
    },
    {
      key: "Type",
      title: "Type",
    },
    {
      key: "Price",
      title: "Price",
    },

    {
      key: "Guests",
      title: "Guests",
    },
    {
      key: "Status",
      title: "Status",
    },
    {
      key: 'action',
      title: 'Action'
    }
  ];


  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <div className="row mb-3 justify-content-between">
                  <div className="col-md-6 mb-2">
                    <h2 className="mainTitle">Listing Management</h2>
                  </div>
                  <div className="col-md-6 mb-2">
                    <div className="addUser">
                      <CustomButton text="Add New Listing" variant='primaryButton' onClick={hanldeRoute} />
                      <CustomInput type="text" placeholder="Search Here..." value={inputValue} inputClass="mainInput" onChange={handleChange} />
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-12">
                    <CustomTable
                      headers={upcomingHeader}

                    >
                      <tbody>
                        {filteredListings?.map((item, index) => (
                          <tr key={index}>
                            <td>{(currentPage - 1) * (itemsPerPage || 10) + index + 1}</td>
                            <td>
                              <img
                                src={getListingImageUrl(item?.media?.[0]?.image_url || item?.linkedMedia?.[0]?.image_url) || male1}
                                className="listingImagePreview"
                                style={{ width: '100px', height: '75px', objectFit: 'cover' }}
                                alt=""
                              />
                            </td>
                            <td className="text-capitalize" style={{ maxWidth: '250px', whiteSpace: 'normal' }}>
                              {item?.title}
                            </td>
                            <td>{item?.location?.city}, {item?.location?.country}</td>
                            <td>{item?.type_of_listing?.listing_name}</td>
                            <td>{`$${item?.pricing?.nightly}/Nightly`}</td>
                            <td>{item?.bedrooms[0]?.no_of_guests}</td>
                            <td>
                              {item?.status == 0 ? 'Draft' : item?.status == 2 ? 'Pending Approval' : 'Active'}
                            </td>
                            <td>
                              <TableDropdown>
                                {(item?.status == 0 || item?.status == 2) && (
                                  <>
                                    <button type="button" className="tableAction"><FontAwesomeIcon icon={faWarning} className="tableActionIcon" />Waiting For Approval</button>
                                    <Link to={`/listing-management/edit-listing/${item?.id}`} className="tableAction"><FontAwesomeIcon icon={faEdit} className="tableActionIcon" />Edit</Link>
                                  </>
                                )}
                                {item?.status == 1 && (
                                  <>
                                    <Link to={`/listing-management/edit-listing/${item?.id}`} className="tableAction"><FontAwesomeIcon icon={faEdit} className="tableActionIcon" />Edit</Link>
                                    <Link to={`/listing-detial/${item?.id}`} className="tableAction"><FontAwesomeIcon icon={faEye} className="tableActionIcon" />View</Link>
                                  </>
                                )}
                                <button type="button" className="tableAction" onClick={() => { handleRemove(item?.id) }}><FontAwesomeIcon icon={faTrash} className="tableActionIcon" />Remove</button>
                              </TableDropdown>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </CustomTable>
                    <CustomPagination
                      itemsPerPage={itemsPerPage}
                      totalItems={data?.total ?? filteredListings.length}
                      currentPage={currentPage}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <CustomModal show={showModal} close={() => { setShowModal(false) }} action={inActive} heading='Are you sure you want to mark this user as inactive?' />
          <CustomModal show={showModal2} close={() => { setShowModal2(false) }} success heading='Marked as Inactive' />

          <CustomModal show={showModal3} close={() => { setShowModal3(false) }} action={ActiveMale} heading='Are you sure you want to mark this user as Active?' />
          <CustomModal show={showModal4} close={() => { setShowModal4(false) }} success heading='Marked as Active' />



        </div>
      </DashboardLayout >
    </>
  );
};
